<template>
  <div>
    <el-row :gutter="20" class="search-and-add-row">
   <el-form :model="queryParams" style="max-width: 500px; width: 100%;">
    <!-- 培训计划选择项 -->
    <el-form-item label="培训计划" label-width="80px">
      <el-select
        v-model="queryParams.trainingPlanId"
        placeholder="请选择培训计划"
        size="small"
        @change="fetchData"
        style="width: 100%;"
      >
        <el-option
          v-for="plan in trainingPlanOptions"
          :key="plan.planId"
          :label="plan.planName"
          :value="plan.planId"
        />
      </el-select>
    </el-form-item>

    <!-- 重置按钮 -->
    <el-form-item>
      <el-button
        size="small"
        @click="resetQuery"
        style="width: 100%;"
      >
        重置
      </el-button>
    </el-form-item>
  </el-form>
 </el-row>
    <!-- 数据表格 -->
    <el-table :data="tableData" style="width: 100%" border>
      <el-table-column prop="id" label="编号" width="60" />
      <el-table-column prop="trainingPlanId" label="培训计划编号" width="140" />
      <el-table-column prop="planName" label="培训计划名字" width="140" />
      <el-table-column prop="organizationId" label="组织编号" width="140" />
      <el-table-column
        prop="question_ids"
        label="问题编号"
      />
      <el-table-column prop="createdAt" label="创建时间" width="180" />
      <el-table-column prop="updatedAt" label="更新时间" width="180" />
      <el-table-column label="操作" width="200">
        <template #default="scope">
          <el-button type="primary" size="small" @click="editRecord(scope.row)">编辑</el-button>
          <el-button type="danger" size="small" @click="deleteRecord(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      @current-change="handlePageChange"
      @size-change="handleSizeChange"
      :current-page="pagination.page"
      :page-size="pagination.pageSize"
      :total="pagination.total"
      layout="total, sizes, prev, pager, next"
    />

    <!-- 编辑弹窗 -->
    <el-dialog v-model="editDialogVisible" title="编辑问题" width="50%">
      <el-form :model="editForm" :rules="rules" ref="editFormRef" label-width="120px">
        <el-form-item label="培训计划编号" prop="trainingPlanId">
          <el-input v-model="editForm.trainingPlanId" />
        </el-form-item>

        <el-form-item label="组织编号" prop="organizationId">
          <el-input v-model="editForm.organizationId" />
        </el-form-item>
        <el-form-item label="问题编号" prop="questionIds">
          <el-input v-model="editForm.question_ids" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveEdit">保存</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ElMessage } from "element-plus";
import axios from "@/axios";

export default {
  props: {
    userid: {
      type: Number,
      required: true,
    },
    organizationID: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      // 查询参数
      queryParams: {
        trainingPlanId: null, // 下拉框选中的培训计划 ID
      },
      // 模拟下拉框数据
      trainingPlanOptions: [],
      // 表格数据
      tableData: [],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      editDialogVisible: false,
      editForm: {},
      rules: {
        trainingPlanId: [{ required: true, message: "请输入培训计划编号", trigger: "blur" }],
        organizationId: [{ required: true, message: "请输入组织编号", trigger: "blur" }],
      },
    };
  },
  methods: {
    // 模拟获取数据
    fetchData() {
      const { page, pageSize } = this.pagination;
      const trainingPlanId = this.queryParams.trainingPlanId || 0; // 防止为 null
      const OrganizationID = this.organizationID;

      // 获取培训计划数据
      axios.get('/Manage/plans', { params: { OrganizationID, planName: '', page: 0, size: 1000 } })
          .then(response => {
            const { data } = response;
            this.trainingPlanOptions = data.data;

            // 获取考试数据
            axios
                .get("/Manage/exam", {
                  params: { trainingPlanId, page, pageSize, OrganizationID },
                })
                .then((res) => {
                  this.tableData = res.data.data.map(item => {
                    const plan = this.trainingPlanOptions.find(plan => plan.planId === item.trainingPlanId);
                    return {
                      ...item,
                      planName: plan ? plan.planName : '未知计划', // 处理未找到计划的情况
                      question_ids: item.question_ids || [], // 确保 question_ids 是数组
                    };
                  });
                  this.pagination.total = res.data.total;
                })
                .catch(() => {
                  ElMessage.error("获取数据失败");
                });
          })
          .catch(error => {
            console.error('获取培训计划失败:', error);
            ElMessage.error('获取数据失败');
          });
    },

    // 重置查询条件
    resetQuery() {
      this.queryParams.trainingPlanId = null;
      this.fetchData();
    },

    // 编辑记录
    editRecord(row) {
      // 确保 question_ids 是字符串格式，如果是数组，转化为逗号分隔的字符串
      this.editForm = { ...row };
      if (Array.isArray(this.editForm.question_ids)) {
        this.editForm.question_ids = this.editForm.question_ids.join(", ");
      }
      this.editDialogVisible = true;
    },

    // 保存编辑
    saveEdit() {
      console.log(this.editForm); // 检查提交的数据
      this.editDialogVisible = false;
      axios
        .post("/Manage/exam", this.editForm)
        .then((response) => {
          if (response.data.success) {
            ElMessage.success(response.data.data);
            this.fetchData();
          } else {
            ElMessage.error(response.data.errorMsg);
          }
        })
        .catch(() => {
          ElMessage.error("保存失败");
        });
    },

    // 分页变化
    handlePageChange(page) {
      this.pagination.page = page;
      this.fetchData();
    },

    // 每页显示数量变化
    handleSizeChange(size) {
      this.pagination.pageSize = size;
      this.fetchData();
    },

    // 删除记录
    deleteRecord(id) {
      axios
        .delete(`/Manage/exam/${id}`)
        .then(response => {
          if (response.data.success) {
            ElMessage.success('删除成功');
            this.fetchData();
          } else {
            ElMessage.error(response.data.errorMsg);
          }
        })
        .catch(() => {
          ElMessage.error("删除失败");
        });
    }
  },

  created() {
    // 初始化数据
    this.fetchData();
    console.log(this.userid)
    console.log(this.organizationID)
  },
};
</script>
